import { render, staticRenderFns } from "./from-transfer.vue?vue&type=template&id=774745a5&scoped=true&"
import script from "./from-transfer.vue?vue&type=script&lang=js&"
export * from "./from-transfer.vue?vue&type=script&lang=js&"
import style0 from "./from-transfer.vue?vue&type=style&index=0&id=774745a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774745a5",
  null
  
)

export default component.exports